import PropTypes from 'prop-types';
import Flex from '@/components/Flex';

const defaultProps = {
  children: null,
};

const propTypes = {
  children: PropTypes.node,
};

export default function CardTitle({
  children,
}) {
  return (
    <Flex direction="row" alignItems="center" inject>
      <h3 className="font-semibold text-xl mb-4">
        {children}
      </h3>
    </Flex>
  );
}

CardTitle.defaultProps = defaultProps;
CardTitle.propTypes = propTypes;
